import { AlphaBCircleIcon } from './AlphaBCircleIcon';

/**
 * author: Contributors
 * id 433A1CBB-57A4-44DA-8B93-B65AF6E54B1D
 * name alpha-b-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-b-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterBCircleIcon = AlphaBCircleIcon;
export default LetterBCircleIcon